<!--
 * @Description:
-->
<template>
    <div>
      <!-- 顶部图片 -->
      <div class="top-pic">
        <img src="../../assets/job/job-banner.png" alt="">
      </div>
      <div class="content">
        <div class="content-center">
          <div class="title">人才招聘</div>
          <div v-for="(item,id) in jobs" :key="id">
          <div class="title-binner">{{ item.jobName }}</div>
          <div class="desc">
            <div class="desc-half">
              <div class="desc-title">职位描述</div>

              <div class="desc-text" v-html="item.description">
              </div>
            </div>
            <div class="desc-half">
              <div class="desc-title">招聘条件</div>
              <div class="desc-text" v-html="item.requirement">
              </div>
            </div>
          </div>
        </div>
          <div class="tel">
            联系电话: 010-53340557 人事部 王小姐 <br />
            我们的团队年轻、朝气、充满活力，欢迎有激情、有责任的您加入我们！
          </div>
        </div>
      </div>
    </div>
  </template>

  <script>
  import request from "@/util/request";
  export default {
    data() {
      return {
        jobs:[]
      };
    },
    mounted() {
      this.getJobs()
    },
    methods:{
      getJobs(){
        request.post('/offer/list',{page:0,pageSize:9999}).then((res)=>{
          this.jobs = res.data.content
        })
      }
    }

  };
  </script>
  <style lang="css" scoped>
  .top-pic {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .top-pic img {
    width: 100%;
    max-height: 480px;
    min-height:280px ;
  }
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-center {
    width: 1000px;
  }
  .title {
    font-size: 20px;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 24px;
    border-bottom: 1px solid #eeeeee;
  }
  .title-binner {
    height: 32px;
    line-height: 32px;
    font-size: 18px;
    padding-left: 50px;
    background-color: #ccdde8;
    color: #ffffff;
  }
  .desc {
    display: flex;
    padding: 40px 50px;
  }
  .desc-half {
    width: 50%;
  }
  .desc-title {
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
  }
  .desc-text {
    line-height: 30px;
  }
  .tel {
    font-weight: bold;
    line-height: 30px;
    margin-top: 20px;
    margin-bottom: 53px;
  }
  </style>
